import { render, staticRenderFns } from "./DsdDetails.vue?vue&type=template&id=616aaacd&scoped=true"
import script from "./DsdDetails.vue?vue&type=script&lang=js"
export * from "./DsdDetails.vue?vue&type=script&lang=js"
import style0 from "./DsdDetails.vue?vue&type=style&index=0&id=616aaacd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616aaacd",
  null
  
)

export default component.exports